import clsx from "clsx";
import { Link, useLocation } from "react-router";
import { GameVer, Lang, stripRealm, tturl, useRealm } from "~/util/Lang";
import css from "./ChangeRealm.module.css";
import { ArrowIcon } from "./icons/Arrow";

const LANGS: { lang: Lang; title: string }[] = [
  { lang: "en", title: "English" },
  { lang: "ru", title: "Русский" },
];
const GAME_VERS: { gver: GameVer; title: string }[] = [
  { gver: "c1", title: "Harbingers of War" },
  { gver: "c2", title: "Age of Splendor" },
  { gver: "c3", title: "Rise of Darkness" },
  { gver: "c4", title: "Scions of Destiny" },
  { gver: "c5", title: "Oath of Blood" },
  { gver: "il", title: "Interlude" },
  { gver: "gf", title: "Gracia Final" },
];

export function ChangeRealm() {
  const realm = useRealm();
  const loc = useLocation();
  const path = stripRealm(loc.pathname);

  return (
    <div className={css.root}>
      <div className={css.control}>
        <div className={css.dropdownTrigger}>
          <button
            className={clsx([css.button, css.small])}
            aria-haspopup="true"
            aria-controls="dropdown-menu1"
          >
            <span>{realm.game.toUpperCase()}</span>
            <span className={css.icon}>
              <ArrowIcon w={6} h={6} borderW={2} />
            </span>
          </button>
        </div>
        <div className={css.dropdownMenu} id="dropdown-menu1" role="menu">
          <div className={css.dropdownContent}>
            {GAME_VERS.map((item) => (
              <Link
                key={item.gver}
                to={{
                  pathname: tturl({ ...realm, game: item.gver }, path),
                  search: loc.search,
                }}
                className={css.dropdownItem}
              >
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 500,
                    color: "#fff",
                  }}
                >
                  {realm.game === item.gver && (
                    <span
                      style={{
                        display: "inline-block",
                        marginLeft: -8,
                        width: 8,
                      }}
                    >
                      &#x2022;
                    </span>
                  )}
                  {item.gver.toUpperCase()}
                </div>
                <div style={{ fontSize: 10 }}>{item.title}</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className={css.control}>
        <div className={css.dropdownTrigger}>
          <button
            className={clsx([css.button, css.small])}
            aria-haspopup="true"
            aria-controls="dropdown-menu2"
          >
            <span>{realm.lang.toUpperCase()}</span>
            <span className={css.icon}>
              <ArrowIcon w={6} h={6} borderW={2} />
            </span>
          </button>
        </div>
        <div className={css.dropdownMenu} id="dropdown-menu1" role="menu">
          <div className={css.dropdownContent}>
            {LANGS.map((item) => (
              <Link
                key={item.lang}
                to={{
                  pathname: tturl({ ...realm, lang: item.lang }, path),
                  search: loc.search,
                }}
                className={css.dropdownItem}
              >
                <div style={{ fontSize: 11, fontWeight: 500, color: "#fff" }}>
                  {realm.lang === item.lang && (
                    <span
                      style={{
                        display: "inline-block",
                        marginLeft: -8,
                        width: 8,
                      }}
                    >
                      &#x2022;
                    </span>
                  )}
                  {item.lang.toUpperCase()}
                </div>
                <div style={{ fontSize: 10 }}>{item.title}</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
